import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import "./style.scss";
import { useIsDesktop } from "../../../helpers/useIsDesktop";
import { useSelector } from "react-redux";
import nequiLogo from '../../../assets/images/nequi.svg'
import daviPlata from '../../../assets/images/davi-plata.svg'
import { CardForm } from "./PaymenForms/CardForm/CardForm";
import { NequiForm } from "./PaymenForms/NequiForm/NequiForm";
import { DaviPlata } from "./PaymenForms/DaviPlataForm/DaviPlata";


const NequiPaymentMethodForm = ({basePrice, handlerManagePaymentSecond}) => {
  return (
    <NequiForm
      basePrice={basePrice}
      handlerManagePaymentSecond={handlerManagePaymentSecond}
    />
  )
}
const CreditCardPaymentMethodForm = ({ handlerManagePayment, pricing, basePrice }) => {
  return (
    <CardForm
      handlerManagePayment={handlerManagePayment}
      pricing={pricing}
      basePrice={basePrice}
    />
  )
}
const DaviPlataPaymentMethodForm = ({basePrice, handlerManagePaymentSecond}) => {
  return (
    <DaviPlata
      basePrice={basePrice}
      handlerManagePaymentSecond={handlerManagePaymentSecond}
    />
  )
}

const creditCard = 0
const nequi = 1
const davi = 2

const paymentMethodsMap = {
  [creditCard]: CreditCardPaymentMethodForm,
  [nequi]: NequiPaymentMethodForm,
  [davi]: DaviPlataPaymentMethodForm,
}

const SelectPaymentMethod = ({ children, ref, ...props }) => {

  const [paymentBtnMethod, setPaymentBtnMethod] = useState(creditCard)
  const Component = paymentMethodsMap[paymentBtnMethod]
  return (
    <div>
      <div className="pay-options-col d-flex justify-content-between">
        <button
          className={`pay-debit-credit ${paymentBtnMethod === creditCard ? "payment-active" : "payment-no-active"}`}
          onClick={() => setPaymentBtnMethod(creditCard)}
        >
          <i class="fa-regular fa-credit-card"></i>
          {"Credito/Debito".toLocaleUpperCase()}
        </button>
        <button
          className={`pay-nequi ${paymentBtnMethod === nequi ? "payment-active" : "payment-no-active"}`}
          onClick={() => setPaymentBtnMethod(nequi)}
        >
          <img src={nequiLogo} alt="Nequi Logo" />
        </button>
        <button
          className={`pay-davi ${paymentBtnMethod === davi ? "payment-active" : "payment-no-active" }`}
          onClick={() => setPaymentBtnMethod(davi)}
        >
          <img src={daviPlata} alt="DaviPlata Logo" />
        </button>
      </div>
      <Component {...props} />
    </div>
  )
}

const PaymentMethodFormV2 = ({ handlerManagePayment, handlerManagePaymentSecond, pricing, basePrice }) => {
  const isDesktop = useIsDesktop();
  const countries = useSelector(store => store.countries.countrySelected)

  return (
    <React.Fragment>
      <div
        className=""
        style={isDesktop ? {} : { minHeight: window.innerHeight }}
      >
        <Row
          className="bg-white p-4"
          style={isDesktop ? { borderRadius: "2.5rem" } : {}}
        >
          <Col>
            <Col sm="12">
              <div className="mb-3">
                <h2 className="plan-payment-title">Método de Pago</h2>

                <i className="plan-payment-desc">
                  IMPORTANTE: No se te hará el cobro de tu plan hasta
                  terminar el periodo de Prueba de 30 días
                </i>
              </div>
            </Col>
            <Col sm={12} lg={12}>
              <Col sm={12} lg={12}>
                {countries !== 2 ? (
                  <CreditCardPaymentMethodForm
                    handlerManagePayment={handlerManagePayment}
                    pricing={pricing}
                    basePrice={basePrice}
                  />
                ) : (
                  <SelectPaymentMethod 
                    handlerManagePaymentSecond={handlerManagePaymentSecond}
                    pricing={pricing}
                    basePrice={basePrice}
                  />
                )}
              </Col>
            </Col>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default PaymentMethodFormV2;
